import DOMPurify from 'dompurify';

DOMPurify.addHook('afterSanitizeAttributes', function (node) {
  if ('target' in node) { node.setAttribute('target', '_blank'); }
});

export const sanitizer = DOMPurify.sanitize;